module.exports = __webpack_public_path__ + "img/Product_Services_4.5ab0c81c.png";